import { Component, EventEmitter, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { FilesActions } from 'src/app/common/store/actions/files.actions';

import { CarEditDialogComponent } from '../car-edit/car-edit.component';

import { MessageActions } from 'src/app/common/store/actions/message.actions';
import { selectAuthLoggedIn, selectAuthUserId, selectLoggedInUserDataId } from 'src/app/common/store/state/app.state';
import { ProposalDialogComponent } from 'src/app/public/buy/elements/proposal-dialog/proposal-dialog.component';
import { NumberDialogComponent } from 'src/app/public/common/components/number-dialog/number-dialog.component';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';

import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { ServiceType, ObjectClass } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource, Currency } from 'src/app/public/common/constants/general-basic-data';

import { BuyAction, ProposalAction } from 'src/app/public/buy/constants/buy-basic-data';
import { RentAction, BookingAction } from 'src/app/public/rent/constants/rent-basic-data';
import { KeepAction, JobAction } from 'src/app/public/keep/constants/keep-basic-data';
import { Proposal } from 'src/app/public/buy/models/proposal.model';
import { Booking } from 'src/app/public/rent/models/booking.model';
import { Job } from 'src/app/public/keep/models/job.model';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { MatCalendar } from '@angular/material/datepicker';
import { DealerType } from 'src/app/public/account/constants/dealer-basic-data';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { MessageDialogComponent } from 'src/app/public/common/elements/message-dialog/message-dialog.component';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { Message } from 'src/app/public/common/models/message.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { Price } from 'src/app/public/common/models/string-data.model';
import { JobDialogComponent } from 'src/app/public/keep/elements/job-dialog/job-dialog.component';
import { BookingDialogComponent } from 'src/app/public/rent/elements/booking-dialog/booking-dialog.component';
import { Car } from '../../models/car.model';


@Component({
    selector: 'app-car-card-horizontal',
    templateUrl: './car-card-horizontal.component.html',
    styleUrls: ['./car-card-horizontal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatProgressSpinnerModule, MatIconModule, MatDividerModule, MatCalendar, CdkOverlayOrigin, CdkConnectedOverlay]
})
export class CarCardHorizontalComponent implements OnInit {

  @Input() businessLine?: CarBusinessLine;
  @Input() objectSource: ObjectSource = ObjectSource.SEARCH;
  
  @Input() car: Car = new Car();
  //@Input() isFavorite: boolean = false;;
  @Input() isProvider: boolean = false;
  @Input() loggedInUser: Dealer = new Dealer();
  //isProvider: boolean = false;
  @Input() carImagesFolder: FileData[] = [];

  //isLoggedIn: boolean = false;

  loggedIn$: Observable<boolean>; 
  loggedIn: boolean = false;

  loggedInUserId$: Observable<string | null>;
  loggedInUserId: string = "";

  currentImageIndex: number = 0;

  currentImageIndexSubject:BehaviorSubject<number>;

  currentImage: any;
  
  fetchingImage: boolean = true;

  showBookingCalendar: boolean = false;
  CarBusinessLine = CarBusinessLine;
  DealerType = DealerType;
  ServiceType = ServiceType

  showDetails: boolean = false;

  constructor(
    private router: Router,
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {
      //this.currentUserId$ = store.select(selectLoggedInUserDataId);

      this.loggedIn$ = store.select(selectAuthLoggedIn);
      this.loggedInUserId$ = this.store.select(selectAuthUserId);
      this.currentImageIndexSubject = new BehaviorSubject<number>(0);
    }

  ngOnInit(): void {

    this.loggedInUserId$ = this.store.select(selectLoggedInUserDataId);

    this.loggedInUserId$.subscribe(
      (userId: string | null) =>  {
        this.loggedInUserId = userId!;
        //this.isProvider = (userId! === this.car.ownerId)
        //this.isProvider = (userId !== "" && userId === this.car.providerId);
      }
    );

    this.currentImageIndexSubject.subscribe(
      (i: number) =>  {
        this.currentImage = this.getCarImage(i);
      }
    );
    this.currentImage = this.getCarImage(0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    const latestImagesFolder = changes['carImagesFolder'];
    if (latestImagesFolder != undefined) {
      if ((latestImagesFolder.currentValue?.length as number) === 1) {
        
        this.currentImageIndexSubject.next(0);
      }
    }
  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDate(dt);
  }

  createImageFromBlob(imageData: Blob): any {
    let objectUrl = URL.createObjectURL(imageData);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl);    
  }

  getCarImage(i: number): any{

    if(this.carImagesFolder != undefined && this.carImagesFolder.length > 0 ){
      let objectUrl = URL.createObjectURL(this.carImagesFolder[i].blob);     
      return this.sanitizer.bypassSecurityTrustUrl(objectUrl); 
    }
  }

  openOfferDialog(carId: string): void {
    let amount = 0;
    
    const dialogRef = this.dialog.open(NumberDialogComponent, {
      data: {amount: amount, label: "Offer"}
    });

    dialogRef.afterClosed().subscribe((result: number) => {
      console.log('New offer = '+result+ " car Id = "+carId);

      if(result > 0 )
        this.store.dispatch(DealerActions.createNewCarOfferSubmit( {carId: carId, amount: result }));
    });
  }

    goToCarDetailsPage(carId: string, offerId: string): any{

    switch(this.businessLine!.toString()){

      case CarBusinessLine.BUY.toString(): {
        this.router.navigate(
          ['/buy/details'],
          { queryParams: { carId: carId, offerId: offerId} }
        );
        break;
      }

      case CarBusinessLine.RENT.toString(): {
        this.router.navigate(
          //['/rent/booking'],
          ['/rent/details'],
          { queryParams: { carId: carId, offerId: offerId} }
        );
        break;
      }

    } 
  }

  goToSellerPage(sellerId: string): any{

    this.router.navigate(
      ['/provider-public'],
      { queryParams: { id: sellerId } }
    );
  }

  goToCarEditPage(carId: string){

    this.router.navigate(
      ['/sell'],
      { queryParams: { id: carId} }
      );
  }

  openCarEditDialog(): void {

    const dialogRef = this.dialog.open(CarEditDialogComponent, {
      data: Object.assign(new Car(), this.car)
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      if(result != undefined ){
        //console.log(result)
        
        if(result.id === ''){
          this.store.dispatch(DealerActions.createNewCarSubmit({ car: result }));
        }
        else{
          this.store.dispatch(DealerActions.updateCarSubmit({ carUpdates: result }));
        }
      }    
    });
  }

  deleteCar(carId: string){
    this.store.dispatch(DealerActions.deleteCarSubmit( {carId: carId}));
  }

  openPriceDialog(carId: string): void {
    let amount = 0
    const dialogRef = this.dialog.open(NumberDialogComponent, {
      data: {amount: amount, label: "Price"}
    });

    dialogRef.afterClosed().subscribe((result: number) => {
      //console.log('New price = '+result+ " car Id = "+carId);
      if(result > 0 )
        this.store.dispatch(DealerActions.createNewCarPriceSubmit( {carId: carId, businessLine: CarBusinessLine.BUY, price: new Price(result, Currency.XAF,  0)}));
    });
  }

  nextImage(): void{
    console.log("current = "+this.currentImageIndex);

    if(this.currentImageIndex === this.carImagesFolder.length-1)
      this.currentImageIndex = 0;
    else 
      this.currentImageIndex++;
    console.log("next = "+this.currentImageIndex);
    this.currentImageIndexSubject.next(this.currentImageIndex);
  }

  prevImage(): void{
    console.log("current ="+this.currentImageIndex);
    if(this.currentImageIndex === 0 )
      this.currentImageIndex = this.carImagesFolder.length-1;
    else 
      this.currentImageIndex--;
    
    console.log("prev ="+this.currentImageIndex);
    this.currentImageIndexSubject.next(this.currentImageIndex);
  }

  uploadImage(carId: string, event: any, ): void {

    let files: File[] = event.target.files;
    console.log('file name = '+files[0].name);

    if(files != undefined && files.length > 0){
      this.store.dispatch(FilesActions.uploadCarImageSubmit({ carId: carId, file: files[0] }));
    }
  }

  toggleFavorite(carId: string, offerId: string): any{

    this.store.dispatch(DealerActions.toggleFavoriteSubmit( { objectId: offerId === "" ? carId :offerId, objectClass: offerId === "" ? ObjectClass.CAR : ObjectClass.OFFER, makeFav: !this.car.favorite, businessLine: this.businessLine! }))
  }

  filterBookedDates = (date: Date | null): boolean => {

    let available: boolean = true;

    this.car.allBookings.forEach(
      (booking: Booking) => {
        if (booking.endDate >= ""+date!.valueOf() && ""+date!.valueOf()  >= booking.startDate) {
          available = false;
          return;
        }
      }
    );
    return available;;
  }

  selectCarPrice(): Price{

    switch(this.businessLine!.toString()){

      case CarBusinessLine.BUY.toString(): {
        return this.car.buyPrice;
      }

      case CarBusinessLine.RENT.toString(): {
        return this.car.rentDayRate;
      }

      default: {
        return Price.getDefault();
      }

    }
  }

  getSellerRatingsTotalCount(): number{
    return this.car.providerRatingsSummary.counts == null ? 0 : this.car.providerRatingsSummary.counts!.reduce((a, b) => a + b, 0);
  }

  openMessageDialog(): void {
  
    let msg = new Message();
    msg.senderId = this.loggedInUserId;

    console.log(" hgghgh "+this.loggedInUserId);
    //msg.senderId = "heyy"
    //return;
    
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      data: msg
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      //console.log('New price = '+result+ " car Id = "+carId);
      if(result != undefined ){
        console.log(result);
        result.receiverId = this.car.providerId;
        result.carId = this.car.carId;
        result.offerId = this.car.offerId;
        msg.senderId = ""
        console.log(result)
        this.store.dispatch(MessageActions.sendNewMessageSubmit( { message: result, objectSource: this.objectSource }));
      }  
    });
  }

  openProposalDialog(): void {

    let proposalId: number = this.car.customer ? this.car.proposals.find(prp => prp.customerId === this.loggedInUserId)?.id! : 0
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.car.offerId, proposalId, CarBusinessLine.BUY, this.car.carId);

    const dialogRef = this.dialog.open(ProposalDialogComponent, {
      data: objectData
    });
  }
  
  openBookingDialog(): void {

    let bookingId: number = this.car.customer ? this.car.myBookings.find(bk => bk.customerId === this.loggedInUserId)?.id! : 0
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.car.offerId, bookingId, CarBusinessLine.RENT, this.car.carId);

    const dialogRef = this.dialog.open(BookingDialogComponent, {
      data: objectData
    });
  }

  openJobDialog(serviceType: ServiceType){
      
    let jobId: number = this.car.customer ? +this.car.jobs.find(jb => jb.customerId === this.loggedInUserId && jb.serviceType === serviceType)?.jobId! : 0
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.car.offerId, jobId, CarBusinessLine.KEEP, this.car.carId);

    const dialogRef = this.dialog.open(JobDialogComponent, {

      data: objectData

    });
  }

  goToCustomerPage(){

    switch(this.businessLine!.toString()){

      case CarBusinessLine.BUY.toString(): {
        this.router.navigate(
          //['/customer/buy-ongoing'],
          ['/buy-in/favorites'],
          { fragment: this.car.offerId }
          //{ queryParams: { carId: this.car.carId, offerId: this.car.offerId } }
        );
        break;
      }

      case CarBusinessLine.RENT.toString(): {
        this.router.navigate(
          //['/customer/rent-ongoing'],
          ['/rent-in/favorites'],
          { fragment: this.car.offerId }
          //{ queryParams: { carId: this.car.carId, offerId: this.car.offerId } }
        );
        break;
      }
    } 
  }

  goToProviderPage(){

    switch(this.businessLine!.toString()){

      case CarBusinessLine.BUY.toString(): {
        this.router.navigate(
          //['/provider/buy-ongoing'],
          ['/sell/offer'],
          { fragment: this.car.offerId }
          //{ queryParams: { carId: this.car.carId, offerId: this.car.offerId } }
        );
        break;
      }

      case CarBusinessLine.RENT.toString(): {
        this.router.navigate(
          //['/provider/rent-ongoing'],
          ['/rent-out/offer'],
          { fragment: this.car.offerId }
          //{ queryParams: { carId: this.car.carId, offerId: this.car.offerId } }
        );
        break;
      }
    } 
  }

  executeBuyAction(car: Car, action: BuyAction){

    switch(action) {
      case BuyAction.CLOSE:{
        break;
      }
      case BuyAction.CREATE:{
        break;
      }
      case BuyAction.EDIT:{
        break;
      }
      case BuyAction.PUBLISH:{
        break;
      }
      case BuyAction.SHARE:{
        break;
      }
      case BuyAction.TOGGLE_FAV:{
        break;
      }
    }
  }

  executeRentAction(car: Car, action: RentAction){

    switch(action) {
      case RentAction.CLOSE:{
        break;
      }
      case RentAction.CREATE:{
        break;
      }
      case RentAction.EDIT:{
        break;
      }
      case RentAction.PUBLISH:{
        break;
      }
      case RentAction.SHARE:{
        break;
      }
      case RentAction.TOGGLE_FAV:{
        break;
      }
    }
  }

  executeKeepAction(car: Car, action: KeepAction){

    switch(action) {
      case KeepAction.CLOSE:{
        break;
      }
      case KeepAction.CREATE:{
        break;
      }
      case KeepAction.EDIT:{
        break;
      }
      case KeepAction.PUBLISH:{
        break;
      }
      case KeepAction.SHARE:{
        break;
      }
      case KeepAction.TOGGLE_FAV:{
        break;
      }
    }
  }

  executeProposalAction(proosal: Proposal, action: ProposalAction){

    switch(action) {
      case ProposalAction.ACCEPT:{
        break;
      }
      case ProposalAction.ACCEPT_MODIF:{
        break;
      }
      case ProposalAction.CANCEL:{
        break;
      }
      case ProposalAction.CANCEL_MODIF:{
        break;
      }
      case ProposalAction.COMPLETE:{
        break;
      }
      case ProposalAction.CREATE:{
        break;
      }
      case ProposalAction.EDIT:{
        break;
      }
      case ProposalAction.EDIT_MODIF:{
        break;
      }
      case ProposalAction.REOPEN:{
        break;
      }
      case ProposalAction.SEND:{
        break;
      }
    }
  }

  executeBookingAction(booking: Booking, action: BookingAction){

    switch(action) {
      case BookingAction.ACCEPT_MODIF:{
        break;
      }
      case BookingAction.CANCEL:{
        break;
      }
      case BookingAction.CANCEL_MODIF:{
        break;
      }
      case BookingAction.COMPLETE:{
        break;
      }
      case BookingAction.CONFIRM:{
        break;
      }
      case BookingAction.EDIT_MODIF:{
        break;
      }
      case BookingAction.EDIT:{
        break;
      }
      case BookingAction.REOPEN:{
        break;
      }
      case BookingAction.SEND:{
        break;
      }
    }
  }

  executeJobAction(job: Job, action: JobAction){

    switch(action) {
      case JobAction.ACCEPT:{
        break;
      }
      case JobAction.ACCEPT_MODIF:{
        break;
      }
      case JobAction.CANCEL:{
        break;
      }
      case JobAction.CANCEL_MODIF:{
        break;
      }
      case JobAction.COMPLETE:{
        break;
      }
      case JobAction.CREATE:{
        break;
      }
      case JobAction.EDIT:{
        break;
      }
      case JobAction.EDIT_MODIF:{
        break;
      }
      case JobAction.REJECT:{
        break;
      }
      case JobAction.REJECT_MODIF:{
        break;
      }
      case JobAction.REOPEN:{
        break;
      }
      case JobAction.SEND:{
        break;
      }
    }
  }

}
